import { useEffect } from 'react';
import type { Result } from '@atlassian/jira-software-fast-virtual';
import { type CardEntry, isCardEntryGroup } from '../../../../model/types';
import { useBacklogSelector, useBacklogDispatch } from '../../../../state';
import { cardAutoScroll } from '../../../../state/actions/cards/auto-scroll';
import { getCardAutoScroll } from '../../../../state/selectors/cards';

export const useAutoScrollCard = (cardEntries: CardEntry[], scrollTo: Result['scrollTo']) => {
	const autoScroll = useBacklogSelector(getCardAutoScroll);
	const dispatch = useBacklogDispatch();

	useEffect(() => {
		const autoScrollCardId = autoScroll?.cardId;
		if (!autoScrollCardId) {
			return;
		}

		// NOTE: Auto scrolling to a subtask may not work as expected
		const cardIndex = cardEntries.findIndex((issueEntry) =>
			isCardEntryGroup(issueEntry)
				? issueEntry.cardIds.includes(autoScrollCardId)
				: issueEntry.cardId === autoScrollCardId,
		);

		if (cardIndex === -1) return;

		return scrollTo(cardIndex, {
			immediate: true,
			onComplete: () => dispatch(cardAutoScroll(null)),
		});
	}, [autoScroll, cardEntries, dispatch, scrollTo]);
};
